import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 30, className = "", testid }) {
  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-[0.68rem] uppercase tracking-widest2 text-lavender ${className}`}>
      {children}
    </p>
  );
}

export function LineReveal({ lines, className = "", lineClass = "", baseDelay = 0.15 }) {
  return (
    <h1 className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: baseDelay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}

export function ParallaxImage({ src, alt, className = "", strength = 60, imgClass = "" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-strength, strength]);
  return (
    <div ref={ref} className={`img-frame ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className={`absolute inset-0 h-[125%] w-full -top-[12.5%] object-cover ${imgClass}`}
        data-testid="parallax-image"
      />
    </div>
  );
}
